// removed by extract-text-webpack-plugin
module.exports = {"carouselModal":"carouselModal","carouselModal__buttonClose":"carouselModal__buttonClose","carouselModal__buttonClose__icon":"carouselModal__buttonClose__icon","carouselModal__subTitle":"carouselModal__subTitle","carouselModal__text":"carouselModal__text","link":"link","isMobile":"isMobile","enableModal":"enableModal","fadeIn":"fadeIn","disableModal":"disableModal","fadeOut":"fadeOut"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/CarouselModal.scss
// module id = 561
// module chunks = 0